@if (loading) {
  <app-loader />
}

@if (!loading) {
  <div class="md-content rd-3" >
    <i class="material-icons md-close"(click)="close()">close</i>
    @if (form) {
      <form [formGroup]="form" (ngSubmit)="save()">
        <div class="md-header text-center">
          <h3>{{'SHARED.createInvoiceModal.invoice' | translate}}</h3>
          <p>{{currentStore?.name}}</p>
        </div>
        <div class="md-body">
          <div class="row">
            <div class="col-md-12">
              <app-text-input label="{{'SHARED.createInvoiceModal.nameLabel' | translate}}" formControlName="clientName" [submitAttempted]="submitAttempted"
              placeholder="{{'SHARED.createInvoiceModal.namePlaceholder' | translate}}" inputType="text" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <app-text-input label="{{'SHARED.createInvoiceModal.emailLabel' | translate}}" formControlName="clientEmail" [submitAttempted]="submitAttempted"
              placeholder="{{'SHARED.createInvoiceModal.emailPlaceholder' | translate}}" inputType="text" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <app-text-input label="{{'SHARED.createInvoiceModal.vat' | translate}}" formControlName="clientVat" [submitAttempted]="submitAttempted"
              placeholder="{{'SHARED.createInvoiceModal.vat' | translate}}" [invalidMsg]="'SHARED.createInvoiceModal.invalidVat' | translate" inputType="text" />
            </div>
          </div>
          @if (availablePaymentMethods?.length > 0) {
            <div class="row">
              <div class="col-md-12">
                <app-dropdown-input-v2 formControlName="paymentMethod"
                  placeholder="{{'SHARED.createInvoiceModal.paymentMethod' | translate}}"
                  label="{{'SHARED.createInvoiceModal.paymentMethod' | translate}}" [options]="availablePaymentMethods"
                textOption="name" [submitAttempted]="submitAttempted" />
              </div>
            </div>
          }
          <div>
            <div class="md-header text-center mt-2">
              <h3>{{'GENERAL.services' | translate}}</h3>
            </div>
            @if (productsFormArray.length) {
              <div class="product-list mb-4" formArrayName="products">
                @for (day of productsFormArray.controls; track day; let i = $index) {
                  <div class="product-line d-flex-center-between" [formGroupName]="i">
                    <div class="text-blue">
                      {{day.get('name').value}}
                    </div>
                    <div class="d-flex-center-between">
                      <div class="text-muted text-right pr-3">
                        {{ getProductPrice(day.get('price').value, day.get('tax').value) | currency:this.merchant.currency}}
                      </div>
                      <div class="text-muted text-right clickable">
                        <a (click)="removeProduct(i)"><i class="material-icons icon">delete</i></a>
                      </div>
                    </div>
                  </div>
                }
                <div class="product-line total d-flex-center-between pt-2 pb-2">
                  <div class="text-muted">Total</div>
                  <strong class="text-blue">{{getTotalValue(productsFormArray.value) | currency:this.merchant.currency}}</strong>
                </div>
              </div>
            }
            <div class="text-center">
              @if (!showAddServiceDropdown) {
                <button type="button" class="btn btn-md btn-primary mb-2" (click)="showAddServiceDropdown = true">{{'SHARED.createInvoiceModal.addService' | translate}}</button>
              }
              @if (showAddServiceDropdown) {
                <div>
                  <app-dropdown-input [options]="availableProducts" formControlName="addProduct" optionProperty="name" placeholder="{{'SHARED.createInvoiceModal.addService' | translate}}" />
                </div>
              }
            </div>
            @if (showIsentionReasonDropdown) {
              <div class="text-center mt-3">
                <div>
                  <app-dropdown-input [options]="isentionReasons" formControlName="isentionReason"
                    [submitAttempted]="submitAttempted"
                  placeholder="{{'SHARED.createInvoiceModal.isentionReason' | translate}}" />
                </div>
              </div>
            }
            <!-- <pre>
            {{form.value | json}}
          </pre> -->
        </div>
      </div>
      <div class="md-actions">
        <div class="row">
          <div class="col">
            <app-alert [msg]="errorMsg" type="danger" />
          </div>
        </div>
        <div class="row">
          <div class="col text-center">
            <app-submit-btn inputClasses="btn-md" [loading]="saving" [hasError]="errorMsg" [disabled]="productsFormArray.length === 0" [btnCopy]="'SHARED.createInvoiceModal.invoice' | translate" />
          </div>
        </div>
      </div>
    </form>
  }
</div>
}
